export default __webpack_public_path__ + "static/media/CSFAQHeader.e175c6df.png";